import React from 'react'
import axios from 'axios'
import { List, Box, Typography, Input, Button, 
TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal,Pagination } from '@mui/material'
import { useRedirect } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';

import EditIcon from '@mui/icons-material/Edit';

import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'

import legolasApi from '../../api/legolas'
import DeleteIcon from '@mui/icons-material/Delete'
import { useParams} from "react-router-dom"
import ChannelDropDown from '../common/ChannelDropDown';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function CouponList() {
  const [totalCount, setTotalcount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [searchString, setSearchstring] = React.useState('')
  const [deleteModal, setdeleteModal] = React.useState(false);
  const [selectedCouponId, setSelectedCouponId] = React.useState(null);
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    {id: '_id', label: 'ID'},
    {id: 'name', label: 'Rule Name'}, {id: 'couponCode', label: 'Coupon Code'},, 
    {id: 'active', label: 'Active' },{id: 'fromDate', label: 'Start From'},{id: 'toDate', label: 'End To'},{id: 'channelName', label: 'Channel'},{id: 'couponProvider', label: 'Coupon Provider'},
  ])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [channelData, setChannelData] = React.useState([]);
  const [filterValue, setFilterValue] = React.useState('');
  const [loading,setLoading] = React.useState(false);
  const { id } = useParams();
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const redirect = useRedirect()
  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
        //setChannelData(res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  }

  const getAllCoupon = () => {
    const channelFilterParam = userChannels.length > 0 ? `&channels=${userChannels.join(',')}` : '';

    axios.get(`${legolasApi.url}/coupon/coupon/listall?${channelFilterParam}`).then((res) => {
      console.log('order res: ', res.data.data.count)
      const data = res.data.data.data, count = res.data.data.count
      console.log("list", data)
      setListData(data)
      setTotalcount(count)
    }).catch((error) => console.log('Error in getting coupons: ', error))
  }
  React.useEffect(() => {
    getChannel();
    getAllCoupon();
  }, [searchString === ''])

  const handleFilter = (field, value) => {
    let newFilterValue = '';
    if (field === 'channel') {
      newFilterValue = value !== null ? value : '';
    }
    setFilterValue(newFilterValue);
    setCurrentPage(1); // Reset pagination

    const effectiveChannels = newFilterValue ? newFilterValue : userChannels.length > 0 ? userChannels.join(',') : '';

    const channelParam = effectiveChannels ? `&channels=${effectiveChannels}` : '';

    axios.get(`${legolasApi.url}/coupon/coupon/listall?filter=${newFilterValue}${channelParam}`)
      .then((res) => {
        setListData(res.data.data.data);
        setTotalcount(res.data.data.count);
      })
      .catch((error) => console.log('Error in getting coupons: ', error));
  }

  const handleClose = () => {
    setdeleteModal(false)
  };

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }


  const handlePagination = (event, value, field = 'channel') => {

    const newFilterValue = filterValue; // from state
    const effectiveChannels = filterValue ? filterValue : userChannels.length > 0 ? userChannels.join(',') : '';

    const channelParam = effectiveChannels ? `&channels=${effectiveChannels}` : '';


    axios.get(`${legolasApi.url}/coupon/coupon/listall?offset=${value - 1}&filter=${newFilterValue}${channelParam}`)
      .then((res) => {
        setCurrentPage(value);
        setListData(res.data.data.data);
        setTotalcount(res.data.data.count); // update count 

      })
      .catch((error) => console.log('Error in fetching paginated data: ', error));
  }

 
  const handleSearch = () => {
    const searchQuery = searchString
    const selectedChannel = filterValue; // optional

    const channelParam = selectedChannel ? `&channels=${selectedChannel}` : userChannels.length > 0 ? `&channels=${userChannels.join(',')}` : '';

    if (typeof searchQuery == 'string' && searchQuery.length > 0) {
      axios.get(`${legolasApi.url}/coupon/coupon/listall?search=${searchQuery}${channelParam}`).then((res) => {
        const data = res.data.data.data, count = res.data.data.count
        console.log('product res31: ', count)
        setListData(data)
        setTotalcount(count)
      })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    } else {
      console.error('Invalid search query.');
    }
  }

  const handleEditClick = (id) => {
    const redirectUrl = `/edit-coupon/${id}`
    redirect(redirectUrl)
  }
  const createNewRule = (orderId) => {
    const redirectUrl = `/add-coupon`
    redirect(redirectUrl)
  }

  const handleDeleteClick =(id) =>{
    const couponId = id;
    console.log("coupon",id)
    const fetchAll = {
     "deleted":true,
     "active":false
    }
    axios.post(`${legolasApi.url}/coupon/delete-coupon/${couponId}`,fetchAll).then((res)=>{
      console.log("order delete",res)
      setdeleteModal(false)
      getAllCoupon();
    }).catch((error) => console.log('Error in deleting orders: ', error))
  }

  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Coupons</Typography>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              {totalCount} record(s) found
            </Typography>
          </Box>
        </Box>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              margin: '0px 30px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              } 
            }}>
              <Input 
                type='search' 
                sx={{ border: '1px solid #2b3f7a', borderRadius: '20px',height:'40px', marginTop:'20px',marginRight:'5%' }} 
                endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
                placeholder='Seach by Coupon ID, Coupon Code'
                onChange={(e) => setSearchstring(e.target.value)}
              />
              { userChannels.length > 1 && ( <ChannelDropDown channelData={channelData} handleChannelFilter={handleFilter} /> )}
              {/* <Select
                labelId="demo-select-small"
                id="demo-select-small"
                style={{ backgroundColor: 'transparent', backgroundRepeat: 'repeat', color: globalStyles.colors.black, width: 'auto', minWidth: '200px', borderRadius: '20px', border: '1px solid #2b3f7a', marginLeft: '20px' }}
                label={'Action'}
                sx={{
                  '& .MuiSelect-select': {
                    margin: '0px 15px !important',
                    padding: '0px !important'
                  },
                  '& .MuiSelect-icon': {
                    position: 'relative',
                    right: 'unset !important',
                    top: 'unset !important'
                  }
                }}
                defaultValue=''
              >
                <MenuItem value={'delete'}>Active</MenuItem>
                <MenuItem value={'subscribe'}>Inactive</MenuItem>
              </Select> */}
              <Box sx={{ 
                width: '50vw', 
                justifyContent: 'end', 
                textAlign: 'end',
                '& .MuiButton-sizeSmall': {
                  lineHeight: '30px !important' 
                },
                '& .MuiDivider-root': {
                  borderRightWidth: 'thin !important',
                  borderColor: '#2b3f7a'
                }
                }}>
                    <Box sx={{ width: '50%', alignItems: 'center', margin: '20px',marginLeft:"45%" }}>
                <Button variant="contained" sx={globalStyles.createButton} onClick={() => createNewRule()}>
                  Add New Rule
                </Button>
              </Box>
                  {/* <Button sx={globalStyles.listSubheaderIcons} onClick={() => createNewRule()}>
                     Create New Rule <Divider orientation="vertical" flexItem sx={{ padding: '0px 10px' }}/>
                  </Button> */}
                  {/* <Button sx={globalStyles.listSubheaderIcons} onClick={() => setOpenFilters(true)}>
                    <FilterAltIcon/> Filters <Divider orientation="vertical" flexItem sx={{ padding: '0px 10px' }}/>
                  </Button> */}
                  {/* <Modal 
                    open={openFilters} 
                    onClose={() => setOpenFilters(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={globalStyles.modalContainer}>
                      <OrderFilters/>
                    </Box>
                  </Modal> */}
                  {/* <Button sx={globalStyles.listSubheaderIcons} onClick={handleColumnClick}>
                    <SettingsIcon/> Columns <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' }}}/> <Divider orientation="vertical" flexItem sx={{ '& .MuiDivider-root': { borderRightWidth: 'normal' }}}/>
                  </Button> */}
                  {/* <Menu
                    id="basic-menu"
                    anchorEl={anchorCol}
                    open={columnsOpen}
                    onClose={() => setColumnsOpen(false)}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <FormControl>
                      <Box sx={{ margin: '10px 20px' }}>
                        <Typography>
                          {selectedHeaders.length} out of {allTableHeaders.length} visible
                        </Typography>
                      </Box>
                      <Box sx={{ width:'100%', borderTop: '1px solid #2b3f7a', borderBottom: '1px solid #2b3f7a', margin: '10px 20px', width: '92.5%' }}>
                      <FormGroup sx={{ display: 'grid', width: '100%', gridTemplateColumns: 'auto auto auto' }}>
                        {allTableHeaders.map((header) => {
                          if (header.id === 'id') {
                            return (
                              <FormControlLabel control={<Radio/>} label={header.label}/>
                            )
                          } else {
                            return (
                              <FormControlLabel control={
                              <Checkbox 
                                //checked={findChecked(header.id, selectedHeaders)}
                                checked={true}
                                />} 
                                label={header.label}
                                onChange={(e) => selectHeader(header.id, header.label)}
                              />
                            )
                          }
                        })}
                    </FormGroup>
                    </Box>
                    <Box sx={{ display: 'flex', margin: '10px 20px', justifyContent: 'space-between !important', 
                      '& .MuiButton-root': {
                        textTransform: 'capitalize',
                        color: globalStyles.colors.backgroundPrimary
                      }}}
                    >
                      <Button onClick={() => resetTableHeaders()}>Reset</Button>
                      <Button onClick={() => setColumnsOpen(false)}>Cancel</Button>
                    </Box>
                  </FormControl>
                </Menu>
                <Button sx={globalStyles.listSubheaderIcons} onClick={handleClick}>
                  <FileUploadIcon/> Export <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' }}}/>
                </Button> */}
                {/* <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel value="csv" control={<Radio size='small'/>} label="CSV" />
                      <FormControlLabel value="excel" control={<Radio size='small'/>} label="Excel XML" />
                    </RadioGroup>
                    <Box>
                      <Button onClick={() => setAnchorEl(null)}>Cancel</Button>
                      <Button>Export</Button>
                    </Box>
                  </FormControl>
                </Menu> */}
              </Box>
            </Box>
        </Box>
        <Box>
        <Modal
              open={deleteModal}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={globalStyles.modalContainer}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Are you sure you want to delete this Coupon?
                </Typography>
                <Box sx={{
                  display: 'flex', justifyContent: 'end', marginTop: '20px',
                  '& .MuiButton-root': {
                    color: globalStyles.colors.backgroundPrimary,
                    textTransform: 'capitalize'
                  }
                }}>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={() => handleDeleteClick(selectedCouponId)} >OK</Button>
                </Box>
              </Box>
            </Modal>
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                <TableRow>
                  {selectedHeaders.map((header) => [
                    <StyledTableCell align='center'>{header.label}</StyledTableCell>
                  ])}
                  <StyledTableCell align='center'>Action</StyledTableCell>
                  <StyledTableCell align='center'>Delete</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  {listData.map((coupon,key) => {
                   
                    return (
                      <StyledTableRow id={key} key={coupon._id}>
                        {selectedHeaders.map((header) => {
                          if (header.id === 'fromDate' || header.id === 'toDate') {
                            return (
                              <StyledTableCell align='center'>{formatDateAndTime(new Date(coupon.couponValid[header.id]))}</StyledTableCell>
                            )
                          } else if(header.id === 'active') {
                            return (
                              <StyledTableCell align='center'>
                                {coupon[header.id]?'true':'false'}
                              </StyledTableCell>
                            )
                          }
                          else {
                            return (
                              <StyledTableCell align='center'>
                                {coupon[header.id]}
                              </StyledTableCell>
                            )
                          }
                        })}
                        <StyledTableCell align='center'>
                          <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => handleEditClick(coupon._id)}/>
                        </StyledTableCell>
                        <StyledTableCell align='center'>
                          <DeleteIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => {setdeleteModal(true);setSelectedCouponId(coupon._id)}} />
                   
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                    
                  
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{ justifyContent: 'center' }}>
              <Pagination count={Math.ceil(totalCount / 20)} page={currentPage} onChange={handlePagination} />
            </Box>
      </List>
    </React.Fragment>
  )
}

export default CouponList